import { FileText, Send, CheckCircle2, XCircle, Clock } from 'lucide-react';

export const STATUS_CONFIG = {
  rascunho: { label: 'Rascunho', cor: 'bg-gray-100 text-gray-700 border-gray-300', icon: FileText },
  enviada: { label: 'Enviada', cor: 'bg-blue-100 text-blue-700 border-blue-300', icon: Send },
  aceita: { label: 'Aceita', cor: 'bg-green-100 text-green-700 border-green-300', icon: CheckCircle2 },
  recusada: { label: 'Recusada', cor: 'bg-red-100 text-red-700 border-red-300', icon: XCircle },
  expirada: { label: 'Expirada', cor: 'bg-yellow-100 text-yellow-700 border-yellow-300', icon: Clock },
};
